// Dubai - full AC service price list.
const content = {
    slug: 'ac-service-price',
    title: (c) => `AC Service Price in Dubai (${new Date().getFullYear()}) | Full Price List`,
    description: (c) =>
        `Every StringsSG AC service price in Dubai: cleaning ${c.money(c.tables.general[0].wall)}, coil wash ${c.money(c.tables.chemicalWash[0].wall)}, gas, repair and AMC, by unit count.`,
    eyebrow: 'Dubai · Price list',
    h1: 'AC Service Price List for Dubai',
    lead: 'Every service, every unit count, split and ducted, in one place. These are the prices you pay - travel included, no call-out fee on top.',
    image: 'blog/living/repairman-doing-air-conditioner-service.jpg',
    imageAlt: 'AC technician at work in a Dubai home',
    facts: ['Prices in AED', 'Travel included', 'Updated for this year'],
    ctaLabel: 'See the full price list',
    priceTitle: 'Full price list',
    priceIntro: 'Prices fall per unit as you add units. "Ducted" means a concealed ducted unit above the false ceiling.',
    panel: { type: 'priceTable' },
    sections: [
        {
            title: 'What changes the price',
            cards: [
                { title: 'Unit type', body: 'Ducted units cost more than wall splits because the work is done through a ceiling panel, with more parts to reach.' },
                { title: 'Number of units', body: 'The first unit carries the travel and setup; every extra unit on the same visit costs less.' },
                { title: 'Service depth', body: 'Cleaning is maintenance; a coil wash removes baked-on dirt; a full dismantle strips the unit down. Each takes longer.' },
            ],
        },
        {
            title: 'How these prices compare',
            tone: 'muted',
            paragraphs: [
                'Published Dubai prices for a single split-unit cleaning commonly sit between AED 150 and AED 250, and deep coil cleaning for ducted units often costs AED 400 to AED 700. Our prices are set below that range on purpose while we build our customer base in the city, and they are the full price - no separate call-out charge.',
            ],
        },
        {
            title: 'What a typical Dubai home spends in a year',
            cards: [
                { title: 'Studio or 1-bed, district-cooled', body: (c) => `One ducted fan coil: three cleanings a year at ${c.money(c.tables.general[0].ducted)} each, plus a yearly coil wash at ${c.money(c.tables.chemicalWash[0].ducted)}. No gas costs - the building supplies chilled water.` },
                { title: '2-bed apartment, own split units', body: (c) => `Two units on a yearly plan cost ${c.money(c.tables.annual[1].threeTimes)} for three visits. Budget for a gas check only if cooling fades.` },
                { title: 'Townhouse with 4 ducted units', body: (c) => `A cleaning visit for all four costs ${c.money(c.tables.general[3].ducted)}. Most owners add a spring coil wash before the heat.` },
            ],
        },
        {
            title: 'Ready to book?',
            paragraphs: [
                'Each service page has a booking picker for that service. If you are not sure what your unit needs, book a cleaning - the technician tells you on the day if anything more is needed, and you decide before any extra work.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much does AC service cost in Dubai?',
            answer: (c) => `A routine cleaning costs ${c.money(c.tables.general[0].wall)} for one split unit and ${c.money(c.tables.general[0].ducted)} for one ducted unit. A coil chemical wash costs ${c.money(c.tables.chemicalWash[0].wall)}, and a full deep clean ${c.money(c.tables.chemicalOverhaul[0].wall)}.`,
        },
        {
            question: 'Is there a call-out charge?',
            answer: 'No. Travel is included in every price on this page.',
        },
        {
            question: 'Do prices include VAT?',
            answer: 'The prices shown are the total you pay - nothing is added when you book.',
        },
    ],
    schema: {
        name: 'AC Service Prices in Dubai',
        serviceType: 'Air conditioner servicing',
        offers: (c) => [
            { name: 'AC cleaning, 1 split unit', price: c.tables.general[0].wall },
            { name: 'AC cleaning, 1 ducted unit', price: c.tables.general[0].ducted },
            { name: 'Coil chemical wash, 1 split unit', price: c.tables.chemicalWash[0].wall },
            { name: 'Deep cleaning, 1 split unit', price: c.tables.chemicalOverhaul[0].wall },
            { name: 'AMC, 1 unit, 3 visits a year', price: c.tables.annual[0].threeTimes },
            { name: 'Gas top-up R410A, 1 outdoor unit', price: c.tables.gas.R410A.half },
            { name: 'Repair diagnosis visit', price: c.tables.repairDiagnosis },
        ],
    },
}

export default content
